"use strict";

exports.__esModule = true;
var Expressions_1 = require("../core/Expressions");
var Url = function () {
  function Url() {}
  Url.validate = function (value) {
    if (typeof value !== "string") return false;
    value = value.trim();
    if (value === "") return false;
    if (/^(?:(?:(?:https?|ftp):)?\/\/)(localhost)(\:[\d]+)?\/?$/.test(value)) {
      return true;
    }
    return Expressions_1.Url.test(value);
  };
  return Url;
}();
exports.Url = Url;